const map = {
	"./Dubrovnik_dark.avif": 3023,
	"./Dubrovnik_light.avif": 3605,
	"./carousel/main.avif": 7308,
	"./favicon.png": 239,
	"./favicon_dark.png": 9880,
	"./footer-bg.avif": 287,
	"./photos/city/city-1.avif": 4945,
	"./photos/city/city-2.avif": 3052,
	"./photos/city/city-3.avif": 5931,
	"./photos/interior/bathroom-1.avif": 6949,
	"./photos/interior/bathroom-2.avif": 2864,
	"./photos/interior/bed-1.avif": 4166,
	"./photos/interior/bed-2.avif": 4015,
	"./photos/interior/kitchen-1.avif": 2137,
	"./photos/interior/kitchen-2.avif": 9620,
	"./photos/interior/living-room-1.avif": 2470,
	"./photos/interior/living-room-2.avif": 2319,
	"./photos/view/lounge-1.avif": 2950,
	"./photos/view/lounge-2.avif": 6447,
	"./photos/view/lounge-4.avif": 7377,
	"./photos/view/lounge-8.avif": 2429,
	"./photos/view/view-5.avif": 9337,
	"./photos/view/view-7.avif": 2499,
	"./testimonials/default-avatar.avif": 54,
	"./testimonials/testimonials-1.avif": 4089,
	"./testimonials/testimonials-2.avif": 4004,
	"./testimonials/testimonials-3.avif": 6147,
	"./testimonials/testimonials-4.avif": 4702,
	"./testimonials/testimonials-5.avif": 925,
	"assets/img/Dubrovnik_dark.avif": 3023,
	"assets/img/Dubrovnik_light.avif": 3605,
	"assets/img/carousel/main.avif": 7308,
	"assets/img/favicon.png": 239,
	"assets/img/favicon_dark.png": 9880,
	"assets/img/footer-bg.avif": 287,
	"assets/img/photos/city/city-1.avif": 4945,
	"assets/img/photos/city/city-2.avif": 3052,
	"assets/img/photos/city/city-3.avif": 5931,
	"assets/img/photos/interior/bathroom-1.avif": 6949,
	"assets/img/photos/interior/bathroom-2.avif": 2864,
	"assets/img/photos/interior/bed-1.avif": 4166,
	"assets/img/photos/interior/bed-2.avif": 4015,
	"assets/img/photos/interior/kitchen-1.avif": 2137,
	"assets/img/photos/interior/kitchen-2.avif": 9620,
	"assets/img/photos/interior/living-room-1.avif": 2470,
	"assets/img/photos/interior/living-room-2.avif": 2319,
	"assets/img/photos/view/lounge-1.avif": 2950,
	"assets/img/photos/view/lounge-2.avif": 6447,
	"assets/img/photos/view/lounge-4.avif": 7377,
	"assets/img/photos/view/lounge-8.avif": 2429,
	"assets/img/photos/view/view-5.avif": 9337,
	"assets/img/photos/view/view-7.avif": 2499,
	"assets/img/testimonials/default-avatar.avif": 54,
	"assets/img/testimonials/testimonials-1.avif": 4089,
	"assets/img/testimonials/testimonials-2.avif": 4004,
	"assets/img/testimonials/testimonials-3.avif": 6147,
	"assets/img/testimonials/testimonials-4.avif": 4702,
	"assets/img/testimonials/testimonials-5.avif": 925
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9741;